import { EqualTo } from './equal-to';
import { GreaterThan } from './greater-than';
import { GreaterThanInclusive } from './greater-than-inclusive';
import { LessThan } from './less-than';
import { LessThanInclusive } from './less-than-inclusive';
import { Operator } from './operator';
import { Range } from './range';

/**
 * Converts string input to respective Operator.
 */
export class OperatorBuilder {
	private constructor() { }

	public static build(type: string): Operator {
		switch (type) {
			case 'lessThan':
				return new LessThan();
			case 'lessThanInclusive':
				return new LessThanInclusive();
			case 'greaterThan':
				return new GreaterThan();
			case 'greaterThanInclusive':
				return new GreaterThanInclusive();
			case 'range':
				return new Range();
			case 'equalTo':
				return new EqualTo();
			default:
				throw new Error('Operator not valid.');
		}
	}
}
